var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"nav"}},[_c('div',{attrs:{"id":"main-title"}},[_vm._v("BD Kreator")]),_vm._l((_vm.getRoutes),function(route,index){return _c('router-link',{key:index,attrs:{"to":route.to}},[_vm._v(_vm._s(route.text))])})],2),(_vm.loaded)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }